import styled from "styled-components";

export const SCButtonMB = styled.button`
  color: #fff;
  font-size: 14px;
  font-weight: bold;
  width: 100%;
  height: 38px;
  border-radius: 26px;
  background-color: #004fff;
  border: none;
  cursor: pointer;
  padding: 12px;
`;

export const SCButtonAddInput = styled.button`
    width: auto;
    max-width: ${(props) => (props.mWidth ? props.mWidth : "unset")};
    height: 32px;
    border-radius: 26px;
    background: ${(props) => (props.background ? props.background : "transparent !important")};
    border:${(props) =>
      props.background
        ? `1px solid ${props.background} !important`
        : props.name === "remove"
        ? "1px solid #FF5666 !important"
        : props.name === "new"
        ? "1px solid #004fff !important"
        : "1px solid #B2B2B7 !important"};
    color: ${(props) =>
      props.color
        ? props.color
        : props.name === "remove"
        ? "#FF5666 !important"
        : props.name === "new"
        ? "#004fff !important"
        : "#B2B2B7 !important"};
    font-size: 14px;
    cursor: pointer;
    padding: 7px 15px;
    font-weight: ${(props) => (props.background ? 500 : 400)};
    margin: ${({ mt = 0, ml = 0, mb = 0, mr = 0 }) => `${mt} ${mr} ${mb} ${ml}`} !important;
    font-family: 'Quicksand',sans-serif;
`;
